export const isKeycloakAuthEnabled = () => {
  const orgName = typeof window !== "undefined" ? window.location.hostname.split(".").shift() : "";
  const ENVIRONMENT_NAME = process.env.ENVIRONMENT_NAME;

  return (
    process.env.AUTH_USE_KEYCLOAK === "true" ||
    process.env.AUTH_USE_KEYCLOAK === true ||
    (ENVIRONMENT_NAME !== "production" && orgName === "november")
  );
};
